// Thin-outline Save (floppy) icon matching the 20x20 / #111113 visual weight of
// the other MT toolbar icons (Download, Search, Edit). MUI's filled SaveIcon
// rendered much heavier/darker than these, so this custom outline version keeps
// the toolbar consistent. Drawn with strokes (like the shared CloseIcon) so the
// weight matches the other outline glyphs.
const MTSaveIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer disk body: rounded top-left, folded top-right corner */}
      <path
        d="M3.333 2.5H13.333L17.5 6.667V17.5H2.5V2.5H3.333Z"
        stroke="#111113"
        strokeWidth="1.3"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Label strip at the top */}
      <path
        d="M5.833 2.5V6.667H12.5V2.5"
        stroke="#111113"
        strokeWidth="1.3"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Inner window at the bottom */}
      <rect
        x="5.833"
        y="10"
        width="8.334"
        height="5"
        stroke="#111113"
        strokeWidth="1.3"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

export default MTSaveIcon
